export default __webpack_public_path__ + "static/media/truck.53fb3ff4.svg";